import React from 'react';
import { formatPromocodeDuration } from './formatPromocodeDuration';
import { useActivatedPromocodesFreePeriodDuration } from './useActivatedPromocodesFreePeriodDuration';

/**
 * returns total formatted duration for all activated not wasted promocodes
 */
export const useActivatedPromocodesFreePeriod = (): string | undefined => {
  const duration = useActivatedPromocodesFreePeriodDuration();

  return React.useMemo(() => (duration ? formatPromocodeDuration(duration) : ''), [duration]);
};
